import { MoreAnalyticsProps } from "./MoreAnalytics.types";

import { ChartsDetails } from "./components/ChartsDetails";

import styles from "./MoreAnalytics.module.scss";

const MoreAnalytics = ({
  post,
  calculation,
  proCalculation,
  proCalculationCharts,
  proCalculationDocument,
  activePosition,
  onPositionChange,
}: MoreAnalyticsProps) => {
  return (
    <div className={styles.analytics}>
      <div className={styles.chartsWrapper}>
        {calculation && (
          <ChartsDetails
            post={post}
            calculation={calculation}
            proCalculation={proCalculation}
            proCalculationCharts={proCalculationCharts}
            proCalculationDocument={proCalculationDocument}
            activePosition={activePosition}
            onPositionChange={onPositionChange}
          />
        )}
      </div>
    </div>
  );
};

export default MoreAnalytics;
